/**
 * Toast global — dispara un evento que AppToast.vue escucha.
 * Uso: showToast('Guardado correctamente', 'success')
 *      showToast('Sync ok', 'success', { position: 'top', duration: 6000 })
 *      showToast('Leer aviso', 'warning', { position: 'top', duration: 0 })  // sticky; solo X
 * Tipos: 'success' | 'danger' | 'warning' | 'info'
 */
export function showToast(message, type = 'success', options = {}) {
  const tipo = type === 'error' ? 'danger' : type
  // Importante: duration 0 debe respetarse (NO usar `duration || 3500`)
  const duration = Object.prototype.hasOwnProperty.call(options, 'duration')
    ? options.duration
    : 3500

  window.dispatchEvent(new CustomEvent('app:toast', {
    detail: {
      message,
      type: tipo,
      position: options.position || 'bottom',
      duration
    }
  }))
}

/**
 * Toast unificado sync ERP: arriba (debajo del navbar) y sticky hasta la X.
 * Respeta result.Message completo (p.ej. aviso checklist de compras en materiales).
 *
 * @param {object|null} result  MgkMessage ({ Number, Message, Type, OData })
 * @param {object} options      { title?: string, fallback?: string }
 */
export function showSyncToast(result, options = {}) {
  const title = options.title || 'Sincronización'
  const d = result?.OData || {}
  const errores = Number(d.errores ?? 0)
  const sinChecklist = Number(d.sinChecklistCompras ?? 0)
  const number = result?.Number
  const ok = number == null ? true : Number(number) >= 0

  let message = (result?.Message && String(result.Message).trim()) || ''

  if (!message) {
    if (ok) {
      const tieneConteo = d.insertados != null || d.actualizados != null || d.errores != null
      message = tieneConteo
        ? `${title} completada.\nInsertados: ${d.insertados ?? 0} | Actualizados: ${d.actualizados ?? 0} | Errores: ${errores}`
        : (options.fallback || `${title} completada.`)
      if (d.activos != null) {
        message += `\nActivos para compra: ${d.activos}.`
      }
    } else {
      message = options.fallback || `${title}: error`
    }
  }

  // Si el backend mandó conteo pero no el texto (o algún proxy lo recortó), rearmar aviso
  if (ok && sinChecklist > 0 && !/checklist de compras/i.test(message)) {
    message +=
      `\n\n⚠ ${sinChecklist} artículo(s) NO tienen el checklist de compras en SAP.\n` +
      'Quedaron inactivos y no aparecerán al buscar en requisiciones/SOC.\n' +
      'Si falta un artículo, consulte al encargado del catálogo en SAP.'
  }

  let type = 'success'
  if (!ok) type = 'danger'
  else if (errores > 0 || sinChecklist > 0) type = 'warning'
  else if (result?.Type === 'warning' || result?.Type === 'info' || result?.Type === 'danger') {
    type = result.Type
  }

  showToast(message, type, { position: 'top', duration: 0 })
}

/** Error de conexión / fallo duro en sync ERP (arriba, sticky). */
export function showSyncError(message) {
  showToast(message || 'Error de conexión al sincronizar', 'danger', { position: 'top', duration: 0 })
}
